<template src="./unitAvailabilitySummary.template.html"></template>
<script>
    import moment from "moment-timezone";
    export default {
        name: "unitAvailabilitySummary",
        props: ["searchObj", "parentCallback"],
        data() {
            return {
                apiUrl: window.location.protocol + '//' + window.location.hostname + (window.location.port ? ":1339" : ''),
                Reservationid: -1,
                confirmationid: -1,
                isAvailable: true,
                showFolio: true,
                variable: false,
                dateObj: {
                    startDate: moment.utc().format("YYYY-MM-DD"),
                    endDate: moment.utc().format("YYYY-MM-DD"),
                },
                BestAvailableRate: {},
                items: [],
                searchflag: null,
                Totalcount: null,
                loading: false,
                availableRoomsList: [],
                isShow: true,
                guestList: [
                ],
                value: 50,
                locationsList: [],
                selectedUnit: [],
                demo3: {
                    value: [0, 100],
                    width: '15%',
                    height: 8,
                    dotSize: 16,
                    min: 0,
                    max: 2000,
                    disabled: false,
                    show: true,
                    useKeyboard: true,
                    tooltip: 'always',
                    formatter: '${value}',
                    enableCross: false,
                    mergeFormatter: '${value1} ~ ${value2}',
                    bgStyle: {
                        backgroundColor: '#fff',
                        boxShadow: 'inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)'
                    },
                    tooltipStyle: {
                        backgroundColor: '#666',
                        borderColor: '#666'
                    },
                    processStyle: {
                        backgroundColor: '#999'
                    }
                },
                folioItemCharges: [],
                folioCharges: {},
                Best_Available_Rate: {},
                filterObj: {
                    value: [null, null],
                    Persons: -99,
                    Adults: -99,
                    Children: -99,
                    startDate: null,
                    endDate: null,
                    Location: -99,
                    FilteredAmenities: [],
                    Beds: 0,
                    Bathrooms: 0,
                    Beds: 0,
                    Bedrooms: 0,
                    PageNo: 1,
                    ItemsPerPage: 20,
                    unitId: null,
                    showguestdropdown: ""
                },
                selectedAddress: {
                    address1:'',
                    cityName:'',
                    stateName:'',
                    countryName: ''
                },
                matchingRoomDetail: null,
                roomsList :[]
            }
        },
        methods: {
            getUnitDetailById() {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                key: "GetUnitDetailById",
                params: {
                    ModuleAction: "GetUnitDetailById",
                    UnitId: vm.searchObj.IsAssigned != 0 ? vm.searchObj.UnitId : vm.searchObj.UnitTypeId,
                    PropertyId: vm.searchObj.PropertyId
                },
                callback: function (err, response) {
                    if (response) {
                        vm.selectedAddress.address1 = response.propertyDetail.Address1
                        vm.selectedAddress.cityName = response.propertyDetail.cityName
                        vm.selectedAddress.stateName = response.propertyDetail.stateName
                        vm.selectedAddress.countryName = response.propertyDetail.countryName
                    } else {
                    console.log(err);
                    }
                }
                });
            },
            bookNow_old(inst) {
                let vm = this;
                console.log("inst===>", inst);
                this.$store.dispatch("selectedUnit", {
                    data: {
                        selectedunit: inst,
                    }
                })
                var selectedUnitData = vm.$store.state.selectedUnitData;
                var selectedUnitSaleStartDate = selectedUnitData.SaleStartDate ? moment(selectedUnitData.SaleStartDate).format('YYYY-MM-DD') : null;
                var selectedUnitSaleEndDate = selectedUnitData.SaleEndDate ? moment(selectedUnitData.SaleEndDate).format('YYYY-MM-DD') : null;
                var selectedStartDate = selectedUnitData.startDate;
                var selectedEndDate = selectedUnitData.endDate;
                
                if ((selectedUnitSaleStartDate && selectedEndDate) && (selectedStartDate >= selectedUnitSaleStartDate && selectedEndDate <= selectedUnitSaleEndDate)) {
                    vm.$router.push("/newReservation/" + -1);
                } else if (selectedUnitSaleStartDate && !selectedUnitSaleEndDate && selectedStartDate >= selectedUnitSaleStartDate) {
                    vm.$router.push("/newReservation/" + -1);
                } else if (!selectedUnitSaleStartDate && !selectedUnitSaleEndDate) {
                    vm.$router.push("/newReservation/" + -1);
                } else {
                    vm.$store.dispatch("toastr", {
                        type: "error",
                        header: "Error",
                        message: "Reservation is not allowed for dates that are blocked or unavailable.",
                    });
                }
            },
            bookNow(inst) {
                let vm = this;
                console.log("inst===>", inst);
            
                // First dispatch to get available rooms
                vm.$store.dispatch("dataRequestHandler", {
                    key: "GetAvailableRooms",
                    params: {
                      ModuleAction: "GetAvailableRooms",
                      Adults: null,
                      Persons: 2,
                      NoOfChildren: null,
                      PropertyID: "",
                      UnitClassId: "",
                      StartDate: inst.startDate,
                      EndDate: inst.endDate,
                      FilteredAmenities: [],
                      reservationId: -1,
                      unitTypeIds: "",
                      searchByUnit: inst.UnitName == "Unassigned" ? false : true,
                      ratePlans: null,
                      promoCodes: null,
                      splitReservations: false,
                    },
                    callback: function (err, response) {
                        if (err) {
                          return;
                        }
                        if (response) {
                            console.log("GetAvailableRooms", response);
                            vm.roomsList = response.roomDetailsListObjs;

                            if(inst.UnitName == "Unassigned"){
                                // Find the matching room detail for unitType
                                vm.matchingRoomDetail = vm.roomsList.find(
                                  roomDetail => roomDetail.UnitId === inst.UnitTypeId
                                );
                            }else{
                                // Find the matching room detail for unit
                                vm.matchingRoomDetail = vm.roomsList.find(
                                  roomDetail => roomDetail.UnitId === inst.UnitId
                                );
                            }

                            // Early return if inventory is 0    3091   UnitTypeId
                            if (vm.matchingRoomDetail?.Unitactualinventory === 0) {
                              vm.$store.dispatch("toastr", {
                                type: "error",
                                header: "Error",
                                message: "Reservation is not allowed for dates that are blocked or unavailable."
                              });
                              return;  // Stop execution here
                            }
                          
                            // If inventory is not 0, continue with the reservation process
                            vm.$store.dispatch("selectedUnit", {
                              data: {
                                selectedunit: inst,
                              }
                            });
                        
                            var selectedUnitData = vm.$store.state.selectedUnitData;
                            var selectedUnitSaleStartDate = selectedUnitData.SaleStartDate ? moment(selectedUnitData.SaleStartDate).format('YYYY-MM-DD') : null;
                            var selectedUnitSaleEndDate = selectedUnitData.SaleEndDate ? moment(selectedUnitData.SaleEndDate).format('YYYY-MM-DD') : null;
                            var selectedStartDate = selectedUnitData.startDate;
                            var selectedEndDate = selectedUnitData.endDate;
                            
                            if ((selectedUnitSaleStartDate && selectedEndDate) && (selectedStartDate >= selectedUnitSaleStartDate && selectedEndDate <= selectedUnitSaleEndDate)) {
                                vm.$router.push("/newReservation/" + -1);
                            } else if (selectedUnitSaleStartDate && !selectedUnitSaleEndDate && selectedStartDate >= selectedUnitSaleStartDate) {
                                vm.$router.push("/newReservation/" + -1);
                            } else if (!selectedUnitSaleStartDate && !selectedUnitSaleEndDate) {
                                vm.$router.push("/newReservation/" + -1);
                            } else {
                                vm.$store.dispatch("toastr", {
                                  type: "error",
                                  header: "Error",
                                  message: "Reservation is not allowed for dates that are blocked or unavailable.",
                                });
                            }
                        }
                    },
                });
            },
            formatMoney(amount) {
                return this.$store.state.getFormattedAmount("$", amount);
            },
            formatDate(date) {
                return moment(date, "YYYY-MM-DD").format("DD MMM ");
            },
            formatStartDate(date) {
                let vm = this;
                let startYear = moment(vm.searchObj.startDate, "YYYY-MM-DD").format("YYYY");
                let endYear = moment(vm.searchObj.endDate, "YYYY-MM-DD").format("YYYY");
                if (startYear == endYear) {
                    return moment(date, "YYYY-MM-DD").format("DD MMM ");
                }
                else {
                    return moment(date, "YYYY-MM-DD").format("DD MMM YYYY");
                }
            },
            updateValues(values) {
                let scope = this;
                console.log("here", values);
                scope.searchObj.startDate = moment(values.startDate).format("YYYY-MM-DDTHH:mm:ss");
                scope.searchObj.endDate = moment(values.endDate).format("YYYY-MM-DDTHH:mm:ss");
                // scope.$emit("getavailability");
                scope.$store.state.bus.$emit("startAndEndTexts", { startDate: scope.searchObj.startDate, endDate: scope.searchObj.endDate });
            },
            formatEndDate(date) {
                let vm = this;
                let startYear = moment(vm.searchObj.startDate, "YYYY-MM-DD").format("YYYY");
                let endYear = moment(vm.searchObj.endDate, "YYYY-MM-DD").format("YYYY");
                return moment(date, "YYYY-MM-DD").format("DD MMM YYYY");
            },
            GetFolioLedgerTransDetails_beforesave() {
                let vm = this;
                let obj = {
                    FolioId: null,
                    ReservationId: null,
                    UnitId: vm.searchObj.UnitId,
                    PropertyId: vm.searchObj.PropertyId,
                    StartDate: vm.searchObj.startDate,
                    EndDate: vm.searchObj.endDate,
                    NumOfAdults: vm.searchObj.Adults,
                    NumOfChildren: vm.searchObj.Children,
                    Persons: vm.searchObj.Persons,
                    RatePlanId: vm.searchObj.RatePlanId
                };
                vm.folioItemCharges = [];
                vm.folioCharges = {};
                console.log("obj", obj)
                vm.$store.dispatch("dataRequestHandler", {
                    key: "GetFolioLedgerTransDetails",
                    params: obj,
                    callback: function (err, response) {
                        if (err) {
                            console.log(err);
                            return
                        }
                        else {
                            console.log("response in GetFolioLedgerTransDetails", response);
                            if (response) {
                                if (response[0]) {
                                    vm.folioItemCharges = response[0]
                                }
                                if (response[2]) {
                                    vm.folioCharges = response[2][0];
                                }
                                if (response[3]) {
                                    vm.BestAvailableRate = response[3][0];
                                }
                            }
                        }
                    }
                })
            },
            showReservationSummaryPanel(inst) {
                let vm = this;
                console.log("inst", inst);
                vm.selectedUnit = inst;
                vm.filterObj.unitId = inst.IsAssigned != 0 ? inst.UnitId : inst.UnitTypeId
                vm.filterObj.Persons = inst.Persons
                vm.filterObj.startDate = inst.startDate
                vm.filterObj.endDate = inst.endDate
                $(".reservationSummary").removeClass("animated fadeOutRight");
                $(".reservationSummary").addClass("expand animated fadeInRight");
                $(".menuMaskRevSum").show();
                vm.getAvailableRooms();
            },
            closeSummaryPannel() {
                let vm = this;
                $(".menuMaskRevSum").hide();
                $(".reservationSummary").removeClass("expand animated fadeInRight");
                $(".reservationSummary").addClass("animated fadeOutRight");
            },
            closeShoppingCart() {
                let vm = this;
                vm.searchObj.startDate = null;
                vm.searchObj.endDate = null;
                vm.searchObj.RatePlanId = null;
                vm.searchObj.Promocode = null;

                $(".menuMaskRevSum").hide();
                $(".reservationSummary").removeClass("expand");

            },
            closeSumPanel() {
                $(".menuMaskRevSum").hide();
                $(".reservationSummary").removeClass("expand");
                window.localStorage.setItem("component", "search");
            },
            imageURLS(imgGuid) {
                let isBase64 = /^data:image\/([a-zA-Z]*);base64,([^\"]*)/.test(imgGuid)
                if (isBase64) {
                    return imgGuid;
                }
                return this.apiUrl + '/downloadImage/' + imgGuid + '/430x300';
            },
            getAvailability() {
                let vm = this;
                if (vm.parentCallback) {
                    // vm.parentCallback();
                }
                // vm.getAvailableRooms();
            },
            getAvailableRooms() {
                let vm = this;
                vm.$store.dispatch("dataRequestHandler", {
                    key: "GetAvailability_BE",
                    params: vm.filterObj,
                    callback: function (err, response) {
                        if (err) {
                            console.log(err);
                            return
                        }
                        else {
                            vm.isAvailable = true;
                            vm.showFolio = true;
                            console.log("response[1].length", response.roomDetailsListObjs.length)
                            vm.GetFolioLedgerTransDetails_beforesave();
                        }
                    }
                })
            },
        },
        computed: {
        },
        mounted() {
            let vm = this;
            this.getUnitDetailById()
        },
        watch: {
            searchObj() {
                this.showReservationSummaryPanel(this.searchObj);
                console.log("searchobj changed")
                this.getUnitDetailById()
            }
        },
        created() {
            let vm = this;
        },
        destroyed() {
        }
    }
</script>